import { render, staticRenderFns } from "./detail_tab_sfi.vue?vue&type=template&id=b6e5dfa0&scoped=true"
import script from "./detail_tab_sfi.vue?vue&type=script&lang=js"
export * from "./detail_tab_sfi.vue?vue&type=script&lang=js"
import style0 from "./detail_tab_sfi.vue?vue&type=style&index=0&id=b6e5dfa0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e5dfa0",
  null
  
)

export default component.exports